
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Container } from 'react-bootstrap';
import { useAuth } from '../../context/AuthContext';
import AdminTopNavbar from './AdminTopNavbar';
import '../../styles/admin.css';
import '../../styles/AdminTopNavbar.css';

const AdminLayout = ({ children, title, subtitle, requiredRoles = ['admin', 'coach'] }) => {
  const { user, isAuthenticated, loading } = useAuth();

  // Mostrar loading mientras se verifica la autenticación
  if (loading) {
    return (
      <>
        <AdminTopNavbar />
        <div className="admin-main-content">
          <Container fluid className="p-0">
            <div className="text-center p-4">
              <div className="spinner-border text-primary mb-3" role="status">
                <span className="visually-hidden">Verificando autenticación...</span>
              </div>
              <p className="text-muted">Verificando autenticación...</p>
            </div>
          </Container>
        </div>
      </>
    );
  }

  // Verificar si el usuario está autenticado
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  // Verificar si el usuario tiene los roles requeridos
  if (user && !requiredRoles.includes(user.role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return (
    <>
      <AdminTopNavbar />
      <div className="admin-main-content">
        <Container fluid className="p-0">
          {/* Page Header */}
          <div className="page-header mb-4 mx-3 mt-3">
            <div className="d-flex justify-content-between align-items-center flex-wrap">
              <div>
                <h1 className="page-title mb-1">{title}</h1>
                {subtitle && <p className="page-subtitle text-muted mb-0">{subtitle}</p>}
                <small className="text-muted">
                  {new Date().toLocaleDateString('es-ES', {
                    weekday: 'long',
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric',
                  })}
                </small>
              </div>
            </div>
          </div>

          {/* Page Content */}
          <div className="page-content mx-3">
            {children}
          </div>
        </Container>
      </div>
    </>
  );
};

AdminLayout.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  requiredRoles: PropTypes.arrayOf(PropTypes.string),
};

export default AdminLayout;
